//
// BinaryTree
//
//
// Binary tree constructed from wizard/flow-3.pdf
// nodes & edges labeled with a bfs algorithm

import Node from './Node';
import Edge from './Edge';

export default class BinaryTree {
  constructor() {
    this.nodes = [];
    this.edges = [];

    this.nodes[0] = new Node('Distance');
    this.nodes[1] = new Node('Size');
    this.nodes[2] = new Node('Packing');
    this.nodes[3] = new Node('Packing');
    this.nodes[4] = new Node('Packing');
    this.nodes[5] = new Node('Moving Details');
    this.nodes[6] = new Node('Moving Details');
    this.nodes[7] = new Node('Moving Details');
    this.nodes[8] = new Node('Moving Details');
    this.nodes[9] = new Node('Moving Details');
    this.nodes[10] = new Node('Local Estimation Boxes Hours');
    this.nodes[11] = new Node('Call ASAP');
    this.nodes[12] = new Node('Local Estimation Hours');
    this.nodes[13] = new Node('Call ASAP');
    this.nodes[14] = new Node('Local Estimation Boxes');
    this.nodes[15] = new Node('Call ASAP');
    this.nodes[16] = new Node('Pricing as a Bell-Curve');
    this.nodes[17] = new Node('Call ASAP');
    this.nodes[18] = new Node('Schedule Walkthrough');
    this.nodes[19] = new Node('Call ASAP');
    this.nodes[20] = new Node('Review');
    this.nodes[21] = new Node('Review');
    this.nodes[22] = new Node('Schedule Walkthrough');
    this.nodes[23] = new Node('Schedule Walkthrough');
    this.nodes[24] = new Node('Confirmation Call');
    this.nodes[25] = new Node('Confirmation Call');
    this.nodes[26] = new Node('Scheduled Thanks');
    this.nodes[27] = new Node('Review');
    this.nodes[28] = new Node('Review');
    this.nodes[29] = new Node('Confirmation Call');
    this.nodes[30] = new Node('Confirmation Call');
    
    this.edges[0] = new Edge(['']);
    this.edges[1] = new Edge(['1-2 Br']);
    this.edges[2] = new Edge(['3 Br', '4 Br', '5 Br']);
    this.edges[3] = new Edge(['Business']);
    this.edges[4] = new Edge(['Yes - Pack It All', 'Yes - A Few Items']);
    this.edges[5] = new Edge(['No']);
    this.edges[6] = new Edge(['Yes - Pack It All', 'Yes - A Few Items']);
    this.edges[7] = new Edge(['No']);
    this.edges[8] = new Edge(['']);
    this.edges[9] = new Edge(['Local Zip']);
    this.edges[10] = new Edge(['Long Zip']);
    this.edges[11] = new Edge(['Local Zip']);
    this.edges[12] = new Edge(['Long Zip']);
    this.edges[13] = new Edge(['Local Zip']);
    this.edges[14] = new Edge(['Long Zip']);
    this.edges[15] = new Edge(['Local Zip']);
    this.edges[16] = new Edge(['Long Zip']);
    this.edges[17] = new Edge(['Local Zip']);
    this.edges[18] = new Edge(['Long Zip']);
    this.edges[19] = new Edge(['']);
    this.edges[20] = new Edge(['']);
    this.edges[21] = new Edge(['']);
    this.edges[22] = new Edge(['']);
    this.edges[23] = new Edge(['']);
    this.edges[24] = new Edge(['']);
    this.edges[25] = new Edge(['']);
    this.edges[26] = new Edge(['']);
    this.edges[27] = new Edge(['']);
    this.edges[28] = new Edge(['']);
    this.edges[29] = new Edge(['']);
    
    this.edges[0].setParent(this.nodes[0]).setChild(this.nodes[1]);
    this.edges[1].setParent(this.nodes[1]).setChild(this.nodes[2]);
    this.edges[2].setParent(this.nodes[1]).setChild(this.nodes[3]);
    this.edges[3].setParent(this.nodes[1]).setChild(this.nodes[4]);
    this.edges[4].setParent(this.nodes[2]).setChild(this.nodes[5]);
    this.edges[5].setParent(this.nodes[2]).setChild(this.nodes[6]);
    this.edges[6].setParent(this.nodes[3]).setChild(this.nodes[7]);
    this.edges[7].setParent(this.nodes[3]).setChild(this.nodes[8]);
    this.edges[8].setParent(this.nodes[4]).setChild(this.nodes[9]);
    this.edges[9].setParent(this.nodes[5]).setChild(this.nodes[10]);
    this.edges[10].setParent(this.nodes[5]).setChild(this.nodes[11]);
    this.edges[11].setParent(this.nodes[6]).setChild(this.nodes[12]);
    this.edges[12].setParent(this.nodes[6]).setChild(this.nodes[13]);
    this.edges[13].setParent(this.nodes[7]).setChild(this.nodes[14]);
    this.edges[14].setParent(this.nodes[7]).setChild(this.nodes[15]);
    this.edges[15].setParent(this.nodes[8]).setChild(this.nodes[16]);
    this.edges[16].setParent(this.nodes[8]).setChild(this.nodes[17]);
    this.edges[17].setParent(this.nodes[9]).setChild(this.nodes[18]);
    this.edges[18].setParent(this.nodes[9]).setChild(this.nodes[19]);
    this.edges[19].setParent(this.nodes[10]).setChild(this.nodes[20]);
    this.edges[20].setParent(this.nodes[12]).setChild(this.nodes[21]);
    this.edges[21].setParent(this.nodes[14]).setChild(this.nodes[22]);
    this.edges[22].setParent(this.nodes[16]).setChild(this.nodes[23]);
    this.edges[23].setParent(this.nodes[18]).setChild(this.nodes[24]);
    this.edges[24].setParent(this.nodes[20]).setChild(this.nodes[25]);
    this.edges[25].setParent(this.nodes[21]).setChild(this.nodes[26]);
    this.edges[26].setParent(this.nodes[22]).setChild(this.nodes[27]);
    this.edges[27].setParent(this.nodes[23]).setChild(this.nodes[28]);
    this.edges[28].setParent(this.nodes[27]).setChild(this.nodes[29]);
    this.edges[29].setParent(this.nodes[28]).setChild(this.nodes[30]);

    this.root = this.nodes[0];
    this.current = this.root;
    this.path = [];
    this.longest = 0;
  }

  traverse(value) {

    console.log(value);
    
    let edges = this.current.edges;

    // no where else to go
    if (this.edges < 1) {
      return;
    }

    // only one other place to go
    if (edges.length == 1) {
      let edge = edges[0];

      this.path.push(this.current);
      this.current = edge.child;

      return this.current;
    }

    // find the next step
    _.forEach(edges, (edge => {
      if (_.includes(edge.weight, value)) {
        this.path.push(this.current);
        this.current = edge.child;

        return false;
      }
    }));

    return this.current;
  }

  retreat() {
    this.current = this.path.pop();

    return this.current;
  }

  getStepNumber() {
    return this.path.length;
  }

  getLongestPathLength() {
    this.longest = 0;
    this.breadthFirstTraversal([this.current]);

    return this.getStepNumber() + this.longest;
  }

  breadthFirstTraversal(nodes) {

    if (! nodes) {
      return [];
    }

    let node = nodes[nodes.length - 1];

    if (! node) {
      return nodes;
    }

    let edges = node.edges;

    // we're at the end!
    if (edges < 1) {
      return nodes;
    }

    edges.forEach(edge => {
      let child = edge.child;
      let newNodes = nodes.slice();
      newNodes.push(child);

      let path = this.breadthFirstTraversal(newNodes);

      this.longest = path && path.length > this.longest ? path.length : this.longest;
    });
  }

  pathToJson() {
    return [...this.path, this.current].map(node => node.value);
  }

  setCurrentNode(currentNode) {
    this.current = typeof currentNode === 'object' ? currentNode : this.nodes[currentNode];
  }
}
